const ArticleWhyJoin = () => {
  return (
    <div className="bg-black py-20 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Why Join This{" "}
            <span className="text-transparent bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text">
              Cohort?
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Experience a premium learning environment designed for your success
          </p>
        </div>

        {/* Professional Cards Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Personalized Attention Card */}
          <div className="bg-gradient-to-b from-gray-900 to-gray-800 border border-gray-700 rounded-xl p-8 hover:border-blue-500/50 transition-all duration-300 group">
            <div className="flex flex-col h-full">
              <div className="mb-6 ">
                <div className="w-14 h-14 bg-blue-500/10 border border-blue-500/30 rounded-xl flex items-center justify-center mb-4">
                  <span className="text-blue-400 font-bold text-xl">10</span>
                </div>
                <h3 className="text-xl text-left  font-semibold text-white mb-3 group-hover:text-blue-300 transition-colors">
                  Personalized Attention
                </h3>
              </div>
              <p className="text-gray-400 text-left leading-relaxed flex-grow">
                Only 10 seats, so every question matters and nobody gets left
                behind.
              </p>
              <div className="mt-6 pt-4 border-t border-gray-700">
                <div className="flex items-center text-blue-400 text-sm font-medium">
                  <div className="w-2 h-2 bg-blue-400 rounded-full mr-2"></div>
                  Small batch advantage
                </div>
              </div>
            </div>
          </div>

          {/* Step-by-Step Support Card */}
          <div className="bg-gradient-to-b from-gray-900 to-gray-800 border border-gray-700 rounded-xl p-8 hover:border-indigo-500/50 transition-all duration-300 group">
            <div className="flex flex-col h-full">
              <div className="mb-6">
                <div className="w-14 h-14 bg-indigo-500/10 border border-indigo-500/30 rounded-xl flex items-center justify-center mb-4">
                  <svg
                    className="w-7 h-7 text-indigo-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl text-left font-semibold text-white mb-3 group-hover:text-indigo-300 transition-colors">
                  Step-by-Step Support
                </h3>
              </div>
              <p className="text-gray-400 text-left leading-relaxed flex-grow">
                From registration to securing your offer, we're with you for the
                whole journey.
              </p>
              <div className="mt-6 pt-4 border-t border-gray-700">
                <div className="flex items-center text-indigo-400 text-sm font-medium">
                  <div className="w-2 h-2 bg-indigo-400 rounded-full mr-2"></div>
                  End-to-end guidance
                </div>
              </div>
            </div>
          </div>

          {/* Guidance from Vaishnavi Card */}
          <div className="bg-gradient-to-b from-gray-900 to-gray-800 border border-gray-700 rounded-xl p-8 hover:border-pink-500/50 transition-all duration-300 group">
            <div className="flex flex-col h-full">
              <div className="mb-6">
                <div className="w-14 h-14 bg-pink-500/10 border border-pink-500/30 rounded-xl flex items-center justify-center mb-4">
                  <svg
                    className="w-7 h-7 text-pink-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl text-left font-semibold text-white mb-3 group-hover:text-pink-300 transition-colors">
                  Guidance from <span className="text-pink-400">Vaishnavi</span>
                </h3>
              </div>
              <p className="text-gray-400 text-left leading-relaxed flex-grow">
                Your mentor, friend, and industry guide.
              </p>
              <div className="mt-6 pt-4 border-t border-gray-700">
                <div className="flex items-center text-pink-400 text-sm font-medium">
                  <div className="w-2 h-2 bg-pink-400 rounded-full mr-2"></div>
                  Personal mentorship
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center gap-3 bg-gray-900/50 border border-gray-700 rounded-lg px-6 py-3">
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
              <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
            </div>
            <span className="text-gray-300 font-medium">
              Premium cohort experience
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleWhyJoin;
